<template>
    <footer class="footer has-cards">
        <div class="container">
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{currentYear}}
                        <a href="/" target="_blank">Sustainability Innnocenter</a>. All rights reserved.
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <a href="#" class="nav-link" target="_blank">SIC Website</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      currentYear: moment().format("YYYY")
    };
  }
};
</script>
<style>
</style>
